import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { pinia } from './stores/pinia'
import { hydrateAuthFromStorage } from './services/authSession'

// Initialize vee-validate rules
import './plugins/validation'

import '@mdi/font/css/materialdesignicons.css'
import './assets/styles/main.css'

const app = createApp(App)

hydrateAuthFromStorage()

app.use(pinia)
app.use(router)
app.use(vuetify)

app.mount('#app')
